import React from 'react';
import { withRouter } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { i18n } from '../../../../../translate/i18n';
import { Container } from './card.style'
import { Chip } from '@mui/material';

const ActionCard = props => {

  const action = props.data;

  const goToAction = (actionId) => {
    props.history.push(`/form-action/${actionId}`)
  }

  return (
    <Container style={ styles.container } stage={props.stage} onClick={() => goToAction(action._id)}>
      <div style={styles.titleContainer}>
        <div style={styles.equipmentName}>{action.actionText}</div>
      </div>
      <div style={styles.descriptionContainer}>
        <span>{action.equipment.description}</span>
        <span>{action.equipment.serialNumber}</span>
      </div>
      <div style={styles.actionContainer}>
        <div style={styles.label}>{i18n.t('divCalendarActionCard.verification')}</div>
        <div style={styles.action}>{action.questionText}</div>
      </div >
      <div style={styles.actionContainer}>
        <div style={styles.label}>{i18n.t('divCalendarActionCard.equipment')}</div>
        <div style={styles.action}>
          { action.equipment.equipmentModel.name}
        </div>
      </div >
      <div style={styles.actionContainer}>
        <div style={styles.label}>{i18n.t('divCalendarActionCard.place')}</div>
        <div style={styles.action}>{action.equipment.place.path}</div>
      </div >
      <div style={styles.actionContainer}>
        <div style={styles.label}>{i18n.t('divCalendarActionCard.company')}</div>
        <div style={styles.chipsaction}>{action.equipment.companies.map((company) => (<Chip
          key={company._id}
          label={company.name}
          sx={{ marginTop: '5px', cursor:'default'}}
           />))}
        </div>
      </div>
      <div style={styles.actionContainer}>
        <div style={styles.label}>{i18n.t('divCalendarActionCard.accountable')}</div>
        <div style={styles.action}>{action.accountables.length > 0 ? action.accountables.map(({name}) => <Chip label={name} sx={{ m: '3px'}}/>) : i18n.t('divCalendarActionCard.noAccountable')}</div>
      </div>
      <div style={styles.actionContainer}>
        <div style={styles.label}>{i18n.t('divCalendarActionCard.service')}</div>
        <div style={styles.action}>{action.service.equipmentService.serviceType.name} ({action.service.equipmentService.frequency.name})</div>
      </div>
      <div style={styles.actionContainer}>
        <div style={styles.label}>{i18n.t('divCalendarActionCard.serviceAction')}</div>
        <div style={styles.action}>{action.service.inspectedBy.name}</div>
      </div>
    </Container>
  );
}

const styles = {
  container: {
    cursor: 'pointer',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  equipmentName: {
    fontSize: '1rem',
    fontWeight: 'bold'
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  label: {
    color: "#828282",
    fontSize: "0.8rem"
  },
  actionContainer: {
    marginTop: 10
  },
  action: {
    marginTop: -3
  },
  chipsaction: {
    marginTop: -3,
    display: 'flex',
    flexDirection: 'column',
  },
  filterChip: {
    margin: 5,
  },
}


export default withRouter(ActionCard);

